import { render, staticRenderFns } from "./GiftAdPopup.vue?vue&type=template&id=60729946&scoped=true"
import script from "./GiftAdPopup.vue?vue&type=script&lang=js"
export * from "./GiftAdPopup.vue?vue&type=script&lang=js"
import style0 from "./GiftAdPopup.vue?vue&type=style&index=0&id=60729946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60729946",
  null
  
)

export default component.exports